import { isTokenExpired, logout } from "./authUtils";

const fetchWithToken = async (
  url: string,
  options: RequestInit = {}
): Promise<Response> => {
  const token = localStorage.getItem("accessToken");

  if (!token) {
    logout();
    throw new Error("No session found. Please login.");
  }

  if (isTokenExpired(token)) {
    logout();
    throw new Error("Session expired. Login again.");
  }

  const headers: Record<string, string> =
    (options.headers as Record<string, string>) || {};

  if (token) {
    headers["Authorization"] = `Bearer ${token}`;
  }

  options.headers = headers;

  try {
    const response = await fetch(url, options);

    if (response.status === 401) {
      logout();
      throw new Error("Unauthorized");
    }

    return response;
  } catch (error) {
    throw error;
  }
};

export default fetchWithToken;
